(function () {
  const shadowRoots = new Set();
  const ratingSelectors = [
    'amazon-product-rating',
    '[id*="reviews_from_amazon"][id*="amazon_ratings"]',
    '[id*="amazon_ratings"]'
  ];
  const targetTextPattern = /(^|\s)(from|on)\s+Amazon\b/gi;
  const customerTextPattern = /\bAmazon\s+Customer\b/gi;
  const ratingsSourcePattern = /\bglobal ratings\s+from\s*$/i;
  let queued = false;
  let mutationObserver;

  function injectCleanerStyles(root) {
    const styleRoot = root || document;
    if (styleRoot.querySelector && styleRoot.querySelector('#amazon-review-label-cleaner-styles')) return;

    const style = document.createElement('style');
    style.id = 'amazon-review-label-cleaner-styles';
    style.textContent = `
      .amazon-review-label-cleaner-source::before,
      .amazon-review-label-cleaner-source::after {
        content: none !important;
        display: none !important;
        background: none !important;
        background-image: none !important;
        -webkit-mask-image: none !important;
        mask-image: none !important;
      }
      .amazon-review-label-cleaner-source [class*="amazon" i],
      .amazon-review-label-cleaner-source [id*="amazon" i],
      .amazon-review-label-cleaner-source [aria-label*="amazon" i],
      .amazon-review-label-cleaner-source [title*="amazon" i],
      .amazon-review-label-cleaner-source [alt*="amazon" i] {
        opacity: 0 !important;
        pointer-events: none !important;
      }
      .rating-count-container svg.amazon-logo-styles,
      [data-testid="rating-count-container"] svg.amazon-logo-styles,
      .amazon-review-label-cleaner-source + svg.amazon-logo-styles {
        opacity: 0 !important;
        pointer-events: none !important;
      }
    `;

    if (styleRoot === document) {
      document.head.appendChild(style);
    } else {
      styleRoot.appendChild(style);
    }
  }

  function trackShadowRoot(root) {
    if (!root || shadowRoots.has(root)) return;

    shadowRoots.add(root);
    injectCleanerStyles(root);

    if (mutationObserver) {
      mutationObserver.observe(root, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  if (Element.prototype.attachShadow && !window.__amazonReviewLabelCleanerPatched) {
    window.__amazonReviewLabelCleanerPatched = true;

    const originalAttachShadow = Element.prototype.attachShadow;

    Element.prototype.attachShadow = function (init) {
      const root = originalAttachShadow.call(this, init);

      trackShadowRoot(root);
      scheduleClean();

      return root;
    };
  }

  function collectRoots() {
    const roots = new Set();

    shadowRoots.forEach((root) => roots.add(root));

    ratingSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        roots.add(element);

        const appBlock = element.closest('.shopify-app-block');
        if (appBlock) roots.add(appBlock);

        if (element.shadowRoot) {
          trackShadowRoot(element.shadowRoot);
          roots.add(element.shadowRoot);
        }
      });
    });

    document.querySelectorAll('.shopify-app-block').forEach((block) => {
      if (block.querySelector('amazon-product-rating')) roots.add(block);
    });

    return roots;
  }

  function cleanTextNode(node) {
    if (!node.nodeValue || !/Amazon/i.test(node.nodeValue)) return;

    const cleaned = node.nodeValue
      .replace(customerTextPattern, 'Toprank Leather Customer')
      .replace(targetTextPattern, '');
    if (cleaned !== node.nodeValue) {
      node.nodeValue = cleaned.replace(/\s{2,}/g, ' ').trimStart();
    }
  }

  function elementTextIncludesAmazon(element) {
    return [
      element.getAttribute('alt'),
      element.getAttribute('aria-label'),
      element.getAttribute('title'),
      element.getAttribute('data-testid'),
      element.id,
      element.className && element.className.toString()
    ].some((value) => /amazon/i.test(value || ''));
  }

  function isLikelyAmazonLogo(element) {
    const tagName = element.tagName;
    if (!['IMG', 'SVG'].includes(tagName)) return false;

    if (elementTextIncludesAmazon(element)) return true;

    const source = element.getAttribute('src') || element.getAttribute('href') || '';
    if (!/amazon/i.test(source)) return false;

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.width <= 140 && rect.height > 0 && rect.height <= 50;
  }

  function hideAmazonLogos(root) {
    if (!root.querySelectorAll) return;

    root.querySelectorAll('img, svg').forEach((element) => {
      if (isLikelyAmazonLogo(element)) {
        element.dataset.amazonReviewLabelCleanerHidden = 'true';
        element.setAttribute('aria-hidden', 'true');
        element.style.opacity = '0';
        element.style.pointerEvents = 'none';
      }
    });
  }

  function isLikelyAmazonWordmark(element) {
    if (!element.textContent || element.children.length > 3) return false;

    const text = element.textContent.trim().replace(/\s+/g, ' ');
    if (text !== 'amazon') return false;

    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.width <= 140 && rect.height > 0 && rect.height <= 60;
  }

  function hideAmazonWordmarks(root) {
    if (!root.querySelectorAll) return;

    root.querySelectorAll('*').forEach((element) => {
      if (isLikelyAmazonWordmark(element)) {
        element.dataset.amazonReviewLabelCleanerHidden = 'true';
        element.setAttribute('aria-hidden', 'true');
        element.style.opacity = '0';
        element.style.pointerEvents = 'none';
      }
    });
  }

  function hideFollowingInlineBrand(node) {
    let sibling = node.nextSibling;

    while (sibling) {
      if (sibling.nodeType === Node.TEXT_NODE) {
        if (sibling.nodeValue && sibling.nodeValue.trim()) break;
      } else if (sibling.nodeType === Node.ELEMENT_NODE) {
        const rect = sibling.getBoundingClientRect();
        const isSmallInlineBrand = rect.width > 0 && rect.width <= 160 && rect.height > 0 && rect.height <= 80;

        if (!isSmallInlineBrand) break;

        sibling.dataset.amazonReviewLabelCleanerHidden = 'true';
        sibling.setAttribute('aria-hidden', 'true');
        sibling.style.opacity = '0';
        sibling.style.pointerEvents = 'none';
      }

      sibling = sibling.nextSibling;
    }
  }

  function cleanRatingsSourceLines(root) {
    if (!root) return;

    const textNodes = [];

    if (document.createTreeWalker) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();

      while (node) {
        textNodes.push(node);
        node = walker.nextNode();
      }
    } else {
      root.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) textNodes.push(node);
      });
    }

    textNodes.forEach((node) => {
      if (!node.nodeValue || !ratingsSourcePattern.test(node.nodeValue)) return;

      if (!/Toprank Leather/i.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(/\s*$/, ' Toprank Leather®');
      }

      if (node.parentElement) {
        node.parentElement.classList.add('amazon-review-label-cleaner-source');
      }
      hideFollowingInlineBrand(node);
    });
  }

  function walkTextNodes(root) {
    if (!root) return;

    injectCleanerStyles(root instanceof ShadowRoot ? root : document);
    hideAmazonLogos(root);
    hideAmazonWordmarks(root);
    cleanRatingsSourceLines(root);

    if (document.createTreeWalker) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();

      while (node) {
        cleanTextNode(node);
        node = walker.nextNode();
      }

      return;
    }

    root.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        cleanTextNode(node);
      } else if (node.childNodes && node.childNodes.length) {
        walkTextNodes(node);
      }
    });
  }

  function cleanAmazonRatingLabels() {
    collectRoots().forEach(walkTextNodes);
  }

  function scheduleClean() {
    if (queued) return;

    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      cleanAmazonRatingLabels();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      injectCleanerStyles();
      cleanAmazonRatingLabels();
    }, { once: true });
  } else {
    injectCleanerStyles();
    cleanAmazonRatingLabels();
  }

  window.addEventListener('load', cleanAmazonRatingLabels);
  window.addEventListener('pageshow', cleanAmazonRatingLabels);

  mutationObserver = new MutationObserver(scheduleClean);
  mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
  shadowRoots.forEach((root) => {
    mutationObserver.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
})();
